function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import ReactProgressiveImage from 'react-progressive-image';
import isUndefined from 'lodash/isUndefined';
import { Waypoint } from 'react-waypoint';
import publicUrl from '@signal/utils/publicUrl';

var ProgressiveImage = /*#__PURE__*/function (_ReactProgressiveImag) {
  _inherits(ProgressiveImage, _ReactProgressiveImag);

  var _super = _createSuper(ProgressiveImage);

  function ProgressiveImage(props) {
    var _this;

    _classCallCheck(this, ProgressiveImage);

    _this = _super.call(this, props);
    _this.loadImageSuper = _this.loadImage;

    _this.loadImage = function (src, srcSetData) {
      if (isUndefined(src)) return;

      _this.loadImageSuper(src, srcSetData);
    };

    return _this;
  }

  return ProgressiveImage;
}(ReactProgressiveImage);
/**
 * @global
 * This object tracks the image srcs that have been previously loaded before.
 * it is used inside of LazyProgressiveImage to determine if the image can be
 * loaded from cache.
 */


_defineProperty(ProgressiveImage, "defaultProps", {
  placeholder: publicUrl('/images/img-placeholder.svg')
});

export { ProgressiveImage as default };
var imageHasLoadedBefore;

if (!imageHasLoadedBefore) {
  imageHasLoadedBefore = {};
}
/**
 * This component lazy loads images based on when they enter into the viewport.
 * When the component enters into the viewport, a timout is set for the given delay.
 * If the component exists the viewport before the timeout is finished, the timeout
 * is the cancelled. If the component is still inside of the viewport when the
 * timeout is finished, then it switches the src of the wrapped Progressive image
 * to the actual image src (from the placeholder). If, when the component enters
 * into the viewport the image has been previously loaded (determined by the global cache
 * object `imageHasLoadedBefore`) then this delay is bypassed and the image loads immediately.
 */


export var LazyProgressiveImage = /*#__PURE__*/function (_React$Component) {
  _inherits(LazyProgressiveImage, _React$Component);

  var _super2 = _createSuper(LazyProgressiveImage);

  function LazyProgressiveImage() {
    var _this2;

    _classCallCheck(this, LazyProgressiveImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "state", {
      inView: false,
      loadImage: imageHasLoadedBefore[_this2.props.src] ? true : false,
      cancel: null
    });

    _defineProperty(_assertThisInitialized(_this2), "loadImage", function () {
      var _this2$state = _this2.state,
          cancel = _this2$state.cancel,
          loadImage = _this2$state.loadImage;
      if (cancel || loadImage) return;
      var delay = _this2.props.delay;
      var timeout = setTimeout(function () {
        return _this2.setState({
          loadImage: true
        });
      }, delay);

      _this2.setState({
        cancel: function cancel() {
          return clearTimeout(timeout);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleLeave", function () {
      var cancel = _this2.state.cancel;
      var newState = {};

      if (cancel) {
        cancel();
        newState.cancel = null;
      }

      newState.inView = false;

      _this2.setState(newState);
    });

    return _this2;
  }

  _createClass(LazyProgressiveImage, [{
    key: "shouldComponentUpdate",
    value: // eslint-disable-next-line no-unused-vars
    function shouldComponentUpdate(nextProps, nextState) {
      /**
       * This component only needs to re-render when the state changes from not
       * loading the image to loading the image. All other changes from setState
       * do not require a re-render. It's also possible that on instantiation,
       * loadImage will be true, in which case it is also not necessary to ever
       * re-render this component.
       */
      return !this.state.loadImage && nextState.loadImage;
    }
  }, {
    key: "progressiveImageProps",
    get: function get() {
      var _this$props = this.props,
          src = _this$props.src,
          placeholder = _this$props.placeholder,
          rest = _objectWithoutProperties(_this$props, ["src", "placeholder"]);

      var loadImage = this.state.loadImage; // Since we're about to load the image, save it to the global cache object

      if (loadImage) imageHasLoadedBefore[src] = true;
      return _objectSpread({
        // return the placeholder for the image if it's not ready to load yet
        src: loadImage ? src : placeholder,
        placeholder: placeholder
      }, rest);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var cancel = this.state.cancel;
      if (cancel) cancel();
    }
  }, {
    key: "render",
    value: function render() {
      /**
       * I attempted to remove the waypoint when loadImage === true because
       * it would no longer be necessary, however, it messed up the heights of the
       * react-virtualized list where it is currently, primarily used.
       */
      return [/*#__PURE__*/React.createElement(Waypoint, {
        bottomOffset: "-750px",
        topOffset: "-750px",
        key: "waypoint",
        scrollableAncestor: "window",
        onEnter: this.loadImage,
        onLeave: this.handleLeave
      }), /*#__PURE__*/React.createElement(ProgressiveImage, Object.assign({
        key: "image"
      }, this.progressiveImageProps))];
    }
  }]);

  return LazyProgressiveImage;
}(React.Component);

_defineProperty(LazyProgressiveImage, "propTypes", {
  delay: PropTypes.number
});

_defineProperty(LazyProgressiveImage, "defaultProps", {
  delay: 500
});